// Nome mostrado ao público no site (27/10/2026, decisão do CEO): primeiro e
// último nome ("Ana Jorge"), sem os nomes do meio. O nome completo continua
// na ficha do admin.

const PARTICULAS = new Set(['da', 'das', 'de', 'do', 'dos', 'e']);

const capitalizar = (p: string) => p.charAt(0).toLocaleUpperCase('pt') + p.slice(1).toLocaleLowerCase('pt');

/** "ANA amélia de graça JORGE" → "Ana Jorge"; um só nome fica como está. */
export function nomePublico(nome: string | null | undefined, alternativa = 'Prestador'): string {
  const partes = (nome ?? '').trim().split(/\s+/).filter(Boolean);
  if (partes.length === 0) return alternativa;
  const primeiro = capitalizar(partes[0]);
  const ultimo = [...partes.slice(1)].reverse().find((p) => !PARTICULAS.has(p.toLocaleLowerCase('pt')) && /\p{L}/u.test(p));
  return ultimo ? `${primeiro} ${capitalizar(ultimo)}` : primeiro;
}
